// src/features/event/pages/EventMainPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { eventCard, EVENT_LOGO } from "../eventCard";
import { COLOR, FW, RADIUS } from "@/ui/tokens";

export default function EventMainPage() {
    const nav = useNavigate();

    return (
        <div style={eventCard.wrap}>
            <div style={eventCard.card}>
                {/* Header */}
                <div style={eventCard.header}>
                    <div style={eventCard.logoBox}>
                        <img src={EVENT_LOGO} alt="" style={{ width: 28, height: 28, filter: "invert(1)" }} />
                    </div>
                    <h1 style={eventCard.title}>독서노트 현대 백화점 전시 이벤트</h1>
                    <p style={eventCard.subtitle}>참여하고 혜택을 받아가세요 🎁</p>
                </div>

                {/* Body */}
                <div style={eventCard.body}>
                    {/* Event info */}
                    <div style={s.section}>
                        <div style={s.sectionTitle}>📌 이벤트 안내</div>
                        <p style={s.text}>
                            현대 백화점 전시에 가입하며 특별 이벤트를 진행합니다.<br />
                            지금 가입하시면 다양한 혜택을 받으실 수 있습니다.
                        </p>
                    </div>

                    <div style={eventCard.divider} />

                    {/* Rewards */}
                    <div style={s.section}>
                        <div style={s.sectionTitle}>🎁 참여 혜택</div>
                        <ul style={s.rewardList}>
                            <li style={s.rewardItem}>
                                <span style={s.rewardBadge}>혜택 1</span>
                                <span>신규 가입 시 웰컴 포인트 1,000P 즉시 지급</span>
                            </li>
                            <li style={s.rewardItem}>
                                <span style={s.rewardBadge}>혜택 2</span>
                                <span>첫 리뷰 작성 시 추가 포인트 500P 지급</span>
                            </li>
                            <li style={s.rewardItem}>
                                <span style={s.rewardBadge}>혜택 3</span>
                                <span>이벤트 기간 내 가입자 대상 추첨을 통해 도서 상품권 증정</span>
                            </li>
                        </ul>
                    </div>

                    <div style={eventCard.divider} />

                    {/* Period */}
                    <div style={s.section}>
                        <div style={s.sectionTitle}>📅 이벤트 기간</div>
                        <p style={s.text}>
                            2026년 5월 15일 ~ 2026년 5월 18일
                        </p>
                    </div>

                    {/* CTA button */}
                    <button
                        onClick={() => nav("/event/agree")}
                        style={{ ...eventCard.ctaBtn, marginTop: 24, letterSpacing: "-0.2px" }}
                    >
                        지금 참여하기 →
                    </button>
                </div>
            </div>
        </div>
    );
}

const s: Record<string, React.CSSProperties> = {
    section:      { paddingBottom: 20 },
    sectionTitle: { fontSize: 13, fontWeight: FW.bold, color: COLOR.textDark, marginBottom: 10, letterSpacing: "-0.2px" },
    text:         { margin: 0, fontSize: 13, color: "#52525b", lineHeight: 1.7 },
    rewardList:   { margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 10 },
    rewardItem:   { display: "flex", alignItems: "flex-start", gap: 10, fontSize: 13, color: "#52525b", lineHeight: 1.6 },
    rewardBadge:  { flexShrink: 0, padding: "2px 8px", background: COLOR.textDark, color: COLOR.white, borderRadius: RADIUS.full, fontSize: 11, fontWeight: FW.bold },
};